import classNames from "classnames";
import { ButtonClassesProps } from "../types";
import "../styles.scss";

const usePrepareClasses = ({ template, ...props }: ButtonClassesProps) => {
  const classnames = classNames(`button`, {
    "button-primary": props.primary,
    "button-secondary": props.secondary,
    "button-tertiary": props.tertiary,
    "button-primary-alt": props.primaryAlt,
    "button-secondary-alt": props.secondaryAlt,
    [props.className]: props.className,
    "button--disabled": props.disabled,
    "button--full": props.full,
    "button__icon--left": props.iconLeft,
    "button--hasIcon": props.icon,
    "button--compact": props.compact,
    "button--small": props.small,
    "button--short": props.short,
    "button--long": props.long,
    "button--justifyBetween": props.justifyBetween,
    "button--no-margin": props.noMargin,
  });

  return {
    classnames,
  };
};

export default usePrepareClasses;
